module.exports = [{"version":"v1","isLatest":false},{"version":"v2","isLatest":false},{"version":"v3","isLatest":false},{"version":"v4","isLatest":true}]